import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { InventorySubMenu } from '../../../../utils/enums';
import { useStores } from '../../../store';
import { InteractiveDataTable } from '../../../shared/interactive-data-table/interactive-data-table';
import { EmptyState } from '../../../shared/empty-state/empty-state';
import { IconType } from '../../../shared/custom-icon/custom-icon';
import usePromiseFeedback from '../../../shared/promise-feedback/usePromiseFeedback';
import { useAddressColumns } from './addresses-columns-config';
import { addressesFiltersConfig } from '../../../shared/filters/filter-config/addresses-filters';
import { useAddressesCrudConfig } from './addresses-crud-config';
import { getIpFiltersDisplay } from '../../../../utils/filters-util';
import { AddressLimit } from '../../../shared/address-limit/address-limit';

export const Addresses: React.FC = observer(() => {

    const {fwVersionStore, customerStore} = useStores();
    const { getAddresses, selectedFwVersion, isLoading} = fwVersionStore;
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();
    const config = useAddressesCrudConfig(promiseFeedbackFactory);
    const addressesColumns = useAddressColumns();

    useEffect(() => {
        fwVersionStore.setInventoryType(InventorySubMenu.ADDRESSES);
    }, []);

    const filterConfig = useMemo(() => {
        const filters = addressesFiltersConfig(fwVersionStore.selectedVersionAddressGroups, fwVersionStore.selectedVersionRules);
        if(!customerStore.selectedLocation) return filters;
        return getIpFiltersDisplay(customerStore.selectedLocation.ipv6Supported, filters, true);
    }, [fwVersionStore.selectedFwVersion, customerStore.selectedLocation?.ipv6Supported, fwVersionStore.selectedVersionAddressGroups, fwVersionStore.selectedVersionRules]);

    return (
        <div className="addresses" data-testid="addresses">
            <InteractiveDataTable
                filterConfig={filterConfig}
                data={getAddresses}
                columnsConfig={addressesColumns}
                crudConfig={config}
                emptyStateComp={
                    <EmptyState
                        iconType={IconType.AllowEmptyState}
                        subTitle="To add new item click"
                        secondarySubTitle=" Add Address"
                    />
                }
                dataHasLoaded={!!selectedFwVersion}
                isLoading={isLoading}
                defaultSortColumn={'value'}
                statusBadge={<AddressLimit />}
            />
            <div>{promiseContextHolder}</div>
        </div>
    );
});